import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import { defaultData as stackDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/StackBlock/StackBlockDefaultData";

export const defaultData: BaseBlock = {
  ...stackDefaultData,
  id: uuidv4(),
  type: "FormStackBlock",
};
